import { Injectable, inject } from '@angular/core';

import {
  MutationSendFeedbackArgs,
  OperationResponse,
} from 'projects/semeris/src/generated/graphql-models';
import { Observable } from 'rxjs';

import { GraphQLService } from '../../shared/services/graphql.service';
import { FeedbackModalResult } from '../components/feedback-modal/feedback-modal.component';
import { SEND_FEEDBACK } from '../constants/feedback.queries';

@Injectable({ providedIn: 'root' })
export class FeedbackService {
  private readonly graphQlService = inject(GraphQLService);

  public sendMail(content: FeedbackModalResult): Observable<OperationResponse> {
    return this.graphQlService.mutate<OperationResponse, MutationSendFeedbackArgs>(SEND_FEEDBACK, {
      email: content.from,
      message: content.message,
      subject: content.subject,
    });
  }
}
